import classNames from "classnames";
import { MicrophoneIcon } from "../icons";

interface RecordButtonProps {
  disabled?: boolean;
  isLoading: boolean;
  isRecording: boolean;
  onStartRecording: () => void;
}

export function RecordButton({
  disabled,
  isLoading,
  isRecording,
  onStartRecording,
}: RecordButtonProps) {
  return (
    <button
      className={classNames("control-btn recorder-button", {
        disabled: disabled || isLoading,
        "is-loading": isLoading,
      })}
      onClick={onStartRecording}
      disabled={disabled}
      aria-label="Voice input"
      aria-hidden={isRecording}
      tabIndex={isRecording ? -1 : 0}
    >
      <MicrophoneIcon />
    </button>
  );
}
